<template>
  <tr>
    <td
      v-if="$can('edit', 'ServiceTaskType')"
      class="px-1"
      style="width: 5%"
    >
      <v-btn
        style="cursor: move"
        icon
        class="sortHandle"
      >
        <v-icon>drag_handle</v-icon>
      </v-btn>
    </td>
    <td style="width: 10%">
      {{ serviceTaskType.order }}
    </td>
    <td style="width: 30%">
      {{ serviceTaskType.title }}
    </td>
    <td
      class="text-right"
      style="width: 30%"
    >
      <v-chip
        v-if="!serviceTaskType.checklist_use"
        color="error"
        text-color="white"
      >
        Not Included
      </v-chip>
      <span v-else>
        <v-chip
          color="success"
          text-color="white"
        >
          Included
        </v-chip>
        <v-chip
          v-if="serviceTaskType.checklist_browse_all"
          text-color="white"
        >
          Browse
        </v-chip>
      </span>
      <v-chip
        v-if="serviceTaskType.checklist_extras"
        text-color="white"
      >
        Extras
      </v-chip>
    </td>
    <td
      class="text-right"
      style="width: 25%"
    >
      <div class="v-item-group v-btn-group">
        <v-btn
          v-if="$can('edit', 'ServiceTaskType')"
          class="caption"
          @click.native.stop="editServiceTaskType"
        >
          <v-icon
            left
            small
          >
            edit
          </v-icon>
          Edit Task Type
        </v-btn>
      </div>
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'ServiceTaskTypeRow',
    props: {
      serviceTaskType: {
        type: Object,
        required: true
      }
    },
    methods: {
      editServiceTaskType() {
        this.$emit('editServiceTaskType', this.serviceTaskType)
      },
      deleteServiceTaskType() {
        this.$emit('deleteServiceTaskType', this.serviceTaskType)
      }
    }
  }
</script>
